module.exports = __webpack_public_path__ + "img/logo_white.c8e168ce.png";